export  const purposeOfMarketOptions = ["Secondary Market","OffPlan Resale"];